# Support Router
# =======================
Backbone = require 'backbone'
Backbone.$ = $
SupportHelpWizardController = require('./helpWizardController')

class SupportAppRouter extends Backbone.Router
  routes:
    '' : 'initialRedirection',
    'pick-order' : 'renderStepOne',
    'select-issue' : 'renderStepTwo',
    'contact-us': 'renderStepThree',
    'problem-solved': 'renderProblemSolved'
    'ticket-success': 'renderTicketSuccess'
    'chat-success': 'renderChatSuccess'

  initialRedirection:() ->
    if window.landingStep?
      if window.landingStep is "intermediate_page"
        @renderIntermediatePage()
      else if window.landingStep is "step_1"
        SupportHelpWizardController.initOrdersFetch()
      else if window.landingStep is "step_2"
        handleAbruptStepTwoFlow()
    else
      handleAbruptStepTwoFlow()

  renderIntermediatePage: ->
    SupportHelpWizardController.intermediatePage()

  renderStepOne: ->
    unless Groupon.Support.OrdersCollection.hasOrders()
      return Backbone.history.navigate('', {trigger: true})
    if directlyAccessed()
      return Backbone.history.navigate('', {trigger: true})
    hideComponents()
    SupportHelpWizardController.stepOne(Groupon.Support.currentOrder)

  renderStepTwo: ->
    if directlyAccessed()
      return Backbone.history.navigate('', {trigger: true})
    hideComponents()
    SupportHelpWizardController.stepTwo()

  renderStepThree: ->
    if directlyAccessed()
      return Backbone.history.navigate('', {trigger: true})
    hideComponents()
    SupportHelpWizardController.stepThree()

  renderProblemSolved: ->
    if directlyAccessed()
      return Backbone.history.navigate('', {trigger: true})
    hideComponents()
    SupportHelpWizardController.problemSolved()

  renderTicketSuccess: ->
    if directlyAccessed()
      return Backbone.history.navigate('', {trigger: true})
    hideComponents()
    SupportHelpWizardController.ticketSuccess()

  renderChatSuccess: ->
    if directlyAccessed()
      return Backbone.history.navigate('', {trigger: true})
    hideComponents()
    SupportHelpWizardController.chatSuccess()

handleAbruptStepTwoFlow = ->
  if not isCMSEnabled() && Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()
    listener = () ->
      $(document).off( "inbenta-help-wizard-loaded", listener)
      SupportHelpWizardController.abruptStepTwoFlow()

    $(document).on('inbenta-help-wizard-loaded', listener)
  else
    SupportHelpWizardController.abruptStepTwoFlow()

directlyAccessed = ->
  not (Groupon.Support.currentOrder? or Groupon.Support.NOT_ORDER_RELATED? or Groupon.Support.ORDER_NOT_LISTED?)

hideComponents = ->
  window.hideFooterLinks()

module.exports = SupportAppRouter
